export default {"src":"/_next/static/media/ML.70c1d29e.svg","height":18,"width":18};